import * as yup from 'yup';

function serviceType(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'SERVICE_TYPE_IS_REQUIRED',
        defaultMessage: 'Service Type is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_SERVICETYPE_FIELD_MAX_CHARS_64',
        defaultMessage: 'Service Type should be less than 64 chars',
      }),
    );
}

function serviceTypeCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'SERVICE_TYPE_CODE_IS_REQUIRED',
        defaultMessage: 'Service Type Code is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_SERVICETYPECODE_FIELD_MAX_CHARS_32',
        defaultMessage: 'Service Type Code should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      serviceType: serviceType(formatMessage),
      serviceTypeCode: serviceTypeCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
